import Action from './Action';
import Amount from './Amount';
import Animals from './Animals';
import Client from './Client';
import Date from './Date';
import Email from './Email';
import Groomer from './Groomer';
import Owner from './Owner';
import Payment from './Payment';
import PetName from './PetName';
import Phone from './Phone';
import Status from './Status';
import Visits from './Visits';

const tableColumns = {
  action: Action,
  amount: Amount,
  animals: Animals,
  date: Date,
  email: Email,
  groomer: Groomer,
  client: Client,
  owner: Owner,
  payment: Payment,
  petName: PetName,
  phone: Phone,
  status: Status,
  visits: Visits,
};

export default tableColumns;
